<template>
  <div class="machine-list">
    <div class="search-line">
      <div class="left">
        <!-- 设备 -->
        <el-input v-model="queryParams.name" class="search-input mr20" :placeholder="`设备`"></el-input>
        <!-- 查询 -->
        <el-button type="primary" icon="el-icon-search" size="mini" @click="search()">查询</el-button>
        <!-- 导入 -->
        <el-button type="primary" icon="el-icon-upload2" size="mini" @click="importList()">导入</el-button>
        <!-- 新建 -->
        <el-button size="mini" icon="el-icon-plus" type="primary" @click="goNew()">新建</el-button>
      </div>
    </div>
    <div class="page-card">
      <table-header-editor :headers="tableHeaders" class="table-header-editor" />
      <el-tabs v-model="queryParams.type">
        <el-tab-pane v-for="(tab, tabindex) in areas" :key="tabindex" :label="tab.name" :name="`${tab.value}`"></el-tab-pane>
      </el-tabs>
      <el-table
        :data="list"
        :header-cell-class-name="'table-header-cell'"
        @sort-change="sortChange"
        border
      >
        <el-table-column
          v-for="(item) in tableHeaders"
          :key="item.id"
          :type="item.type"
          :label="item.label"
          :prop="item.prop"
          :sortable="!!item.sortKey ? 'custom': false"
          :sort-by="item.sortKey"
          :width="item.width">
            <template slot-scope="scope">
              <span v-if="item.type ==='index'">{{scope.$index + 1}}</span>
              <span v-else-if="item.prop === 'image'">
                <el-image v-for="(img, index) in scope.row[item.prop]" :content="`点击查看大图`" :key="index" :src="img.url" alt="" style="width: 50px;margin-right: 4px;cursor:pointer;" :preview-src-list="scope.row.image.map(i => i.url)"></el-image>
              </span>
              <span v-else>{{scope.row[item.prop]}}</span>
              <!-- 编辑 -->
              <el-tooltip v-if="item.handle" effect="dark" :content="`编辑`" placement="top-start">
                <el-button class="p0 fontsize20" type="text" @click.prevent="goEdit(scope.row)"><i class="el-icon-edit-outline"></i></el-button>
              </el-tooltip>
              <!-- 删除 -->
              <el-tooltip v-if="item.handle" effect="dark" :content="`删除`" placement="top-start">
                <el-button class="p0 fontsize20" type="text" @click.prevent="goDelete(scope.row.id)"><i class="el-icon-delete"></i></el-button>
              </el-tooltip>
            </template>
        </el-table-column>
      </el-table>
      <pagination :queryParams="queryParams" :getList="getList" />
    </div>
    <!-- 设备管理 -->
    <ImportFile
      :link="'/template/basic/equipment/'+`设备管理`+'.xlsx'" ref="importFile"
      @complete="getImport" />
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination.vue'
import TableHeaderEditor from '@/components/common/TableHeaderEditor.vue'
import ImportFile from '@/components/common/ImportFile.vue'
import { machineList, machineDelete, importMachine } from '@/api.js'
import { pageSize } from '@/utils/Config.js'
export default {
  name: 'MachineList',
  components: {
    Pagination,
    TableHeaderEditor,
    ImportFile
  },
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize,
        _total: 0,
        name: ''
      },
      list: [],
      tableHeaders: [],
      areas: []
    }
  },
  watch: {
    'queryParams.type' (newValue) {
      if (newValue) {
        this.getList()
      }
    }
  },
  async mounted() {
    await this.getTypes()
    // this.getList()
  },
  methods: {
    search() {
      this.queryParams.pageIndex = 1
      this.getList()
    },
    getTypes() {
      // 获取容器类型
      return this.$utils.getDict(313)
      .then((options) => {
        if ( options ) {
          this.areas = options[313]
          
          this.queryParams.type = `${this.areas[0].value}`
        }
      })
    },
    importList() {
      // 开始导入
      this.$refs.importFile.show()
    },
    getImport(file) {
      // 接收导入文件信息
      const info = {
        file_id: file.fileId
      }
      this.$request('post', importMachine, info)
      .then((res) => {
        if (res) {
          // this.$message.success('导入成功')
          this.$message.success(`导入成功`)
          this.getList()
        }
      })
    },
    getList() {
      // 获取列表数据
      const url = machineList
      const {
        pageIndex,
        pageSize,
        name,
        type,
        orderBy,
        order
      } = this.queryParams
      const queryParams = {
        page: pageIndex,
        per_page: pageSize,
        name: name.trim(),
        type,
        order_column: orderBy,
        order
      }
      this.$request('get', url, queryParams)
      .then((res) => {
        if (res) {
          const prev = [
            {
              width: 60,
              label: '#',
              prop: '',
              type: 'index',
              checked: true
            }
          ]
          const last = [
            {
              width: 'auto',
              // 操作
              label: `操作`,
              prop: '',
              checked: true,
              handle: true
            }
          ]

          this.tableHeaders = this.tableHeaders.length > 0 ? this.tableHeaders : this.$utils.generateColumns(res.columns, prev, last)
          this.list = res.data
          this.queryParams._total = res.total
        }
      })
    },
    sortChange(item) {
      // 排序方法
      const { column, order } = item
      const orderString = order ? order === 'ascending' ? 'asc' : 'desc' : undefined
      const orderBy = order ? column.sortBy : undefined

      this.queryParams.order = orderString
      this.queryParams.orderBy = orderBy
      this.getList()
    },
    goEdit(item) {
      // 调转编辑页
      this.$router.push(`/basic/machine/edit/${item.id || 0}`)
    },
    goNew() {
      // 跳转新建
      this.$router.push(`/basic/machine/edit/0`)
    },
    goDelete(id) {
      // 确认删除
      this.$confirm(`确认删除吗?`,{
        type: 'warning',
        // 确定
        confirmButtonText: `确定`,
        // 取消
        cancelButtonText: `取消`,
      })
      .then(() => {
        const url = machineDelete.replace('{id}', id)
        this.$request('post', url, {})
        .then((res) => {
          if (res) {
            this.$message.success(`删除成功`)
            this.getList()
          }
        })
      })
      .catch(() => {
        console.log('取消删除')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .machine-list {
    .page-card {
      position: relative;
      .table-header-editor {
        position: absolute;
        right: 10px;
        z-index: 5;
      }
    }
  }
</style>